import { render, staticRenderFns } from "./editEmployeeAdmin.vue?vue&type=template&id=383a0608&scoped=true"
import script from "./editEmployeeAdmin.vue?vue&type=script&lang=js"
export * from "./editEmployeeAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383a0608",
  null
  
)

export default component.exports